<template>
<transition name="slide-fade" mode="out-in"> 
  <div id="index" v-wechat-title="$route.meta.title">
    <img src="@/assets/start1.png" class="img1" />
    <img src="@/assets/start2.png" class="img2 animate__animated animate__zoomIn" />
    <img src="@/assets/start3.png" class="img3 animate__animated animate__zoomIn" />
  </div>
</transition>
</template>
<script>
export default {
  data() {
    return {
        timer: '',
    };
  },
   mounted() {
      this.timer = setTimeout(this.get, 3500);
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
  methods: {
    get() {
      this.$router.push('/index');
    }
  }
};
</script>
<style scoped>
#index {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#index img {
  position: absolute;
    left: 0;
  right: 0;
}
.img1 {
  width: 100%;
  height: 100%;
  /* left: 0; */
  top: 0;
  /* right: 0; */
  z-index: -1;
}
.img2 {
  width: 70%;
  margin: 0 auto;
  top: 30%;
    animation-delay: 0.4s;
  -webkit-animation-delay: 0.4s; /* Safari 和 Chrome */
}
.img3{
  width: 100%;
  margin: 0 auto;
  top: 43%;
   animation-delay: 1.5s;
  -webkit-animation-delay: 1.5s; /* Safari 和 Chrome */
}
.btns {
  /* display: flex; */
  margin-top: 65%;
}
.btns div {
  width: 50%;
  margin: 0 auto;
  background: #226ea7;
  color: white;
  line-height: 3rem;
  height: 3rem;
  border-radius: 5px;
  margin-bottom: 3rem;
  font-weight: bold;
}
.btn1 {
  animation-delay: 0.7s;
  -webkit-animation-delay: 0.7s; /* Safari 和 Chrome */
}
</style>


// WEBPACK FOOTER //
// src/page/start.vue